import {
  Component,
  ViewEncapsulation,
  Injector,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '../../../services/modal.service';
import { ProfileService } from '../../../services/profile.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TermsComponent implements AfterViewInit {
  modalService: any;
  public content: string;
  public withAcceptance: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private injector: Injector,
    private profileServive: ProfileService,
    private elementRef: ElementRef
  ) {
    this.modalService = injector.get(ModalService);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const modalBody =
        this.elementRef.nativeElement.querySelector('.modal-body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }, 0);
  }

  close(result?: { accept?: boolean; logout?: boolean }) {
    this.activeModal.close(result);
  }

  acceptTerms() {
    this.profileServive.acceptTerms().subscribe((result) => {
      if (result) {
        this.close({ accept: true });
      }
    });
  }

  declineTerms() {
    this.profileServive
      .declineTerms()
      .pipe(
        switchMap((result) => {
          if (!result) {
            return false;
          }
          return this.modalService.confirmTermsDecline();
        })
      )
      .subscribe((result) => {
        if (result) {
          this.close({ logout: true, accept: false });
        }
      });
  }
}
